module.exports = "Render the element\n\n-----------------------------------\n=> ReactDOM.render (2 params)\n\n&nbsp;&nbsp;&nbsp;&nbsp;- React element\n\n&nbsp;&nbsp;&nbsp;&nbsp;- DOM node\n\n-----------------------------------\n=> React.createElement (3 params)\n\n&nbsp;&nbsp;&nbsp;&nbsp;- Element type (tag name string / component)\n\n&nbsp;&nbsp;&nbsp;&nbsp;- Props\n\n&nbsp;&nbsp;&nbsp;&nbsp;- Content / Children\n\n-----------------------------------\n=> Get DOM node\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/04_hello_world/notes_4.md
// module id = 1475
// module chunks = 0